import React from 'react';

function FadeUp({ children }) {
  return React.Children.map(children, (child) => {
    return React.cloneElement(child, { 'data-aos': 'fade-up' });
  });
}

export default FadeUp;
